module.exports = __webpack_public_path__ + "static/img/item-bg.65092591.png";